import _sfc_main from './AlertTriggerControls.vue2.js';
import normalizeComponent from '../../_virtual/_plugin-vue2_normalizer.js';

var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "fds-widget fds-alert-trigger-controls", class: { "fds-ui-loading": _setup.isLoadingStoreData } }, [_vm._t("root", function() {
    return [_vm._t("header", function() {
      return [_c(_setup.HoistComponent, [_c(_setup.FactsheetHeader, { attrs: { "id": _vm.securityId, "locale": _vm.locale }, on: { "exchange-change": _setup.onExchangeChange }, scopedSlots: _vm._u([{ key: "price-information:footer", fn: function() {
        return [_c(_setup.UiRenderNothing)];
      }, proxy: true }, { key: "price-information:header:performance-list", fn: function() {
        return [_c(_setup.UiRenderNothing)];
      }, proxy: true }]) })], 1)];
    }, null, { localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule, onExchangeChange: _setup.onExchangeChange }), _vm._t("form", function() {
      return [_c("div", { staticClass: "fds-alert-trigger-controls__form" }, [_vm._t("form:title", function() {
        return [_c("div", { staticClass: "fds-alert-trigger-controls__form-title" }, [_vm._v(_vm._s(_setup.translate("alertTriggerControls.limits")))])];
      }, null, { localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule, label: "alertTriggerControls.limits" }), _vm._t("form:input(upper-limit)", function() {
        return [_c("div", { staticClass: "fds-ui-input fds-alert-trigger-controls__upper-limit", class: { "fds-ui-input--error": !_setup.hasValidUpperLimit } }, [_vm._t("form:input(upper-limit):label", function() {
          return [_c("label", { staticClass: "fds-ui-input__label", attrs: { "for": `fds-alert-trigger-controls-upper-limit-${_setup.elementId}` } }, [_vm._v(" " + _vm._s(_setup.translate("alertTriggerControls.upperLimit")) + " ")])];
        }, null, {
          localizationSupport: _setup.localizationSupport,
          storeModule: _setup.storeModule,
          onCancel: _setup.onCancel,
          onDelete: _setup.onDelete,
          onSave: _setup.onSave,
          hasValidUpperLimit: _setup.hasValidUpperLimit,
          validateUpperLimit: _setup.validateUpperLimit,
          hasValidForm: _setup.hasValidForm,
          validateForm: _setup.validateForm,
          label: "alertTriggerControls.upperLimit"
        }), _vm._t("form:input(upper-limit):field", function() {
          return [_c("div", { staticClass: "fds-ui-input__field" }, [_c("input", { directives: [{ name: "model", rawName: "v-model.number", value: _setup.upperLimit, expression: "upperLimit", modifiers: { "number": true } }], attrs: { "id": `fds-alert-trigger-controls-upper-limit-${_setup.elementId}`, "type": "number", "placeholder": _setup.translate("alertTriggerControls.upperLimitPlaceholder") }, domProps: { "value": _setup.upperLimit }, on: { "input": [function($event) {
            if ($event.target.composing)
              return;
            _setup.upperLimit = _vm._n($event.target.value);
          }, function($event) {
            return _setup.validateUpperLimit();
          }], "blur": function($event) {
            return _vm.$forceUpdate();
          } } }), _setup.storeData?.currency ? _c("span", { staticClass: "fds-ui-input__suffix" }, [_vm._v(" " + _vm._s(_setup.textFormat(_setup.storeData?.currency)) + " ")]) : _vm._e()])];
        }, null, {
          localizationSupport: _setup.localizationSupport,
          storeModule: _setup.storeModule,
          onCancel: _setup.onCancel,
          onDelete: _setup.onDelete,
          onSave: _setup.onSave,
          hasValidUpperLimit: _setup.hasValidUpperLimit,
          validateUpperLimit: _setup.validateUpperLimit,
          hasValidForm: _setup.hasValidForm,
          validateForm: _setup.validateForm,
          label: "alertTriggerControls.upperLimit"
        }), _vm._t("form:input(upper-limit):errors", function() {
          return [_c("ul", { staticClass: "fds-ui-validation-error-bag fds-ui-input__errors" }, _vm._l(_setup.upperLimitValidationErrorsBag, function(error, index) {
            return _c("li", { key: `error-buy-price-${index}`, staticClass: "fds-ui-validation-error-bag__item" }, [_vm._v(" " + _vm._s(_setup.translate(`alertTriggerControls.validationErrors.upperLimit.${error.label}`)) + " ")]);
          }), 0)];
        }, null, { localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule, upperLimitValidationErrorsBag: _setup.upperLimitValidationErrorsBag })], 2)];
      }, null, {
        localizationSupport: _setup.localizationSupport,
        storeModule: _setup.storeModule,
        onCancel: _setup.onCancel,
        onDelete: _setup.onDelete,
        onSave: _setup.onSave,
        hasValidUpperLimit: _setup.hasValidUpperLimit,
        validateUpperLimit: _setup.validateUpperLimit,
        hasValidLowerLimit: _setup.hasValidLowerLimit,
        validateLowerLimit: _setup.validateLowerLimit,
        hasValidForm: _setup.hasValidForm,
        validateForm: _setup.validateForm,
        label: "alertTriggerControls.upperLimit"
      }), _vm._t("form:input(lower-limit)", function() {
        return [_c("div", { staticClass: "fds-ui-input fds-alert-trigger-controls__lower-limit", class: { "fds-ui-input--error": !_setup.hasValidLowerLimit } }, [_vm._t("form:input(lower-limit):label", function() {
          return [_c("label", { staticClass: "fds-ui-input__label", attrs: { "for": `fds-alert-trigger-controls-lower-limit-${_setup.elementId}` } }, [_vm._v(" " + _vm._s(_setup.translate("alertTriggerControls.lowerLimit")) + " ")])];
        }, null, {
          localizationSupport: _setup.localizationSupport,
          storeModule: _setup.storeModule,
          onCancel: _setup.onCancel,
          onDelete: _setup.onDelete,
          onSave: _setup.onSave,
          hasValidLowerLimit: _setup.hasValidLowerLimit,
          validateLowerLimit: _setup.validateLowerLimit,
          hasValidForm: _setup.hasValidForm,
          validateForm: _setup.validateForm,
          label: "alertTriggerControls.lowerLimit"
        }), _vm._t("form:input(lower-limit):field", function() {
          return [_c("div", { staticClass: "fds-ui-input__field" }, [_c("input", { directives: [{ name: "model", rawName: "v-model.number", value: _setup.lowerLimit, expression: "lowerLimit", modifiers: { "number": true } }], attrs: { "id": `fds-alert-trigger-controls-lower-limit-${_setup.elementId}`, "type": "number", "placeholder": _setup.translate("alertTriggerControls.lowerLimitPlaceholder") }, domProps: { "value": _setup.lowerLimit }, on: { "input": [function($event) {
            if ($event.target.composing)
              return;
            _setup.lowerLimit = _vm._n($event.target.value);
          }, function($event) {
            return _setup.validateLowerLimit();
          }], "blur": function($event) {
            return _vm.$forceUpdate();
          } } }), _setup.storeData?.currency ? _c("span", { staticClass: "fds-ui-input__suffix" }, [_vm._v(" " + _vm._s(_setup.textFormat(_setup.storeData?.currency)) + " ")]) : _vm._e()])];
        }, null, {
          localizationSupport: _setup.localizationSupport,
          storeModule: _setup.storeModule,
          onCancel: _setup.onCancel,
          onDelete: _setup.onDelete,
          onSave: _setup.onSave,
          hasValidLowerLimit: _setup.hasValidLowerLimit,
          validateLowerLimit: _setup.validateLowerLimit,
          hasValidForm: _setup.hasValidForm,
          validateForm: _setup.validateForm,
          label: "alertTriggerControls.lowerLimit"
        }), _vm._t("form:input(lower-limit):errors", function() {
          return [_c("ul", { staticClass: "fds-ui-validation-error-bag fds-ui-input__errors" }, _vm._l(_setup.lowerLimitValidationErrorsBag, function(error, index) {
            return _c("li", { key: `error-buy-price-${index}`, staticClass: "fds-ui-validation-error-bag__item" }, [_vm._v(" " + _vm._s(_setup.translate(`alertTriggerControls.validationErrors.lowerLimit.${error.label}`)) + " ")]);
          }), 0)];
        }, null, { localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule, lowerLimitValidationErrorsBag: _setup.lowerLimitValidationErrorsBag })], 2)];
      }, null, {
        localizationSupport: _setup.localizationSupport,
        storeModule: _setup.storeModule,
        onCancel: _setup.onCancel,
        onDelete: _setup.onDelete,
        onSave: _setup.onSave,
        hasValidLowerLimit: _setup.hasValidLowerLimit,
        validateLowerLimit: _setup.validateLowerLimit,
        hasValidForm: _setup.hasValidForm,
        validateForm: _setup.validateForm,
        label: "alertTriggerControls.lowerLimit"
      })], 2)];
    }, null, {
      localizationSupport: _setup.localizationSupport,
      storeModule: _setup.storeModule,
      onCancel: _setup.onCancel,
      onDelete: _setup.onDelete,
      onSave: _setup.onSave,
      hasValidUpperLimit: _setup.hasValidUpperLimit,
      validateUpperLimit: _setup.validateUpperLimit,
      hasValidLowerLimit: _setup.hasValidLowerLimit,
      validateLowerLimit: _setup.validateLowerLimit,
      hasValidForm: _setup.hasValidForm,
      validateForm: _setup.validateForm
    }), _vm._t("actions", function() {
      return [_c("div", { staticClass: "fds-alert-trigger-controls__actions" }, [_vm._t("actions:button(delete)", function() {
        return [_c("button", { staticClass: "fds-ui-button fds-ui-button--primary fds-alert-trigger-controls__button--delete", attrs: { "type": "button", "disabled": _setup.isLoadingStoreData || !_setup.storeData?.id }, on: { "click": _setup.onDelete } }, [_vm._v(" " + _vm._s(_setup.translate("alertTriggerControls.deleteBtn")) + " ")])];
      }, null, { localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule, onCancel: _setup.onCancel, onDelete: _setup.onDelete, onSave: _setup.onSave, label: "alertTriggerControls.deleteBtn" }), _vm._t("actions:button(cancel)", function() {
        return [_c("button", { staticClass: "fds-ui-button fds-ui-button--secondary fds-alert-trigger-controls__button--cancel", attrs: { "type": "button", "disabled": _setup.isLoadingStoreData }, on: { "click": _setup.onCancel } }, [_vm._v(" " + _vm._s(_setup.translate("alertTriggerControls.cancelBtn")) + " ")])];
      }, null, { localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule, onCancel: _setup.onCancel, onDelete: _setup.onDelete, onSave: _setup.onSave, label: "alertTriggerControls.cancelBtn" }), _vm._t("actions:button(save)", function() {
        return [_c("button", { staticClass: "fds-ui-button fds-ui-button--primary fds-alert-trigger-controls__button--save", attrs: { "type": "button", "disabled": _setup.isLoadingStoreData || !_setup.upperLimit && !_setup.lowerLimit || !_setup.hasValidForm }, on: { "click": _setup.onSave } }, [_vm._v(" " + _vm._s(_setup.translate("alertTriggerControls.saveBtn")) + " ")])];
      }, null, { localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule, onCancel: _setup.onCancel, onDelete: _setup.onDelete, onSave: _setup.onSave, label: "alertTriggerControls.saveBtn" })], 2)];
    }, null, {
      localizationSupport: _setup.localizationSupport,
      storeModule: _setup.storeModule,
      onCancel: _setup.onCancel,
      onDelete: _setup.onDelete,
      onSave: _setup.onSave,
      hasValidUpperLimit: _setup.hasValidUpperLimit,
      validateUpperLimit: _setup.validateUpperLimit,
      hasValidLowerLimit: _setup.hasValidLowerLimit,
      validateLowerLimit: _setup.validateLowerLimit,
      hasValidForm: _setup.hasValidForm,
      validateForm: _setup.validateForm
    })];
  }, null, {
    localizationSupport: _setup.localizationSupport,
    storeModule: _setup.storeModule,
    onCancel: _setup.onCancel,
    onDelete: _setup.onDelete,
    onSave: _setup.onSave,
    onExchangeChange: _setup.onExchangeChange,
    hasValidUpperLimit: _setup.hasValidUpperLimit,
    validateUpperLimit: _setup.validateUpperLimit,
    hasValidLowerLimit: _setup.hasValidLowerLimit,
    validateLowerLimit: _setup.validateLowerLimit,
    hasValidForm: _setup.hasValidForm,
    validateForm: _setup.validateForm
  })], 2);
};
var _sfc_staticRenderFns = [];
_sfc_render._withStripped = true;
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
__component__.options.__file = "/home/ubuntu/actions-runner/_work/library/library/packages/library/src/components/alert-trigger-controls/AlertTriggerControls.vue";
var AlertTriggerControls = __component__.exports;

export { AlertTriggerControls as default };
